export default {
  velt: {
    openPanel: 'コメントパネルを開く',
    closePanel: 'コメントパネルを閉じる',
    panel: 'コメントパネル',
    tabs: 'コメントパネルのタブ',
    comments: 'コメント',
    settings: '設定と権限',
    dragOrTapComment: 'ドラッグしてコメントを追加するか、タップしてコメントを表示',
    assignComment: 'コメントを割り当てる',
    markAsUnread: '未読にする',
    markAsRead: '既読にする',
    unsubscribe: '購読を解除',
    subscribe: '購読する',
    deleteThread: 'スレッドを削除',
    editComment: 'コメントを編集',
    emptyPlaceholder: 'フィードバックを送る、質問する、またはチームメンバーにメモを残す',
    searchPlaceholder: 'コメントを検索',
    commentPlaceholder: '{page} にコメント',
    replyPlaceholder: '返信....',
    filterPages: 'ページ',
    filterAuthor: '作成者',
    filterTagged: 'タグ付け',
    statusOpen: '未対応',
    statusResolved: '解決済み',
    anonymous: '匿名',
    settingsPanel: {
      title: '誰がコメントできますか？',
      everyoneLabel: '全員',
      restrictedLabel: '招待された共同作業者のみ',
      emailsLabel: 'メール',
      emailsPlaceholder: 'メールを追加して Enter を押す',
    },
  },
}
